/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useScript } from "../hooks/useScript";
import config from "../config";
import { IGetHSTokenResult, getHSToken } from "../redux/actions/collectOrders";

export default function CollectionOrderHubspotWidget() {
  useScript(
    config.hsLiveChatUrl,
    'hubspot'
  );

  useEffect(() => {
    // HS Settings
    (window as any).hsConversationsSettings = {
      loadImmediately: false,
    };

    // If loaded get token
    if ((window as any).HubSpotConversations) {
      getUserToken();
    }
  }, [(window as any).HubSpotConversations])

  async function getUserToken() {
    getHSToken((res: IGetHSTokenResult) => {
      (window as any).hsConversationsSettings = {
        identificationEmail: res.Email,
        identificationToken: res.Token
      };
      (window as any).HubSpotConversations.widget.load();
    }, (err) => {
    });
  }

  return (
    <></>
  )
}
